import React, { useEffect } from 'react';
import { FourOpinionStyles } from './styles';
import {
  Banner4Opinion,
  Benefits4Opinion,
  Expert4Opinion,
  Experts4Opinion,
  History4Opinion,
  Poll4Opinion,
  Prefooter4Opinion,
  Selection4Opinion,
  ShoppersContact,
} from '../../components';
import MetaFromApi from '../../components/metaFromApi/MetaFromApi';

export const FourOpinion = () => {
  useEffect(() => {}, []);
  return (
    <FourOpinionStyles>
      <MetaFromApi slug="4opinion" />
      <Banner4Opinion />
      {/* <Benefits4Opinion /> */}
      <Expert4Opinion />
      <Poll4Opinion />
      <Selection4Opinion />
      <Experts4Opinion />
      {/* <History4Opinion /> */}
      <Prefooter4Opinion />
      <ShoppersContact />
    </FourOpinionStyles>
  );
};
